<div class="p-3">

    <!-- Upload New Photo -->
    <div class="rana-panel mb-3" style="display:flex;gap:12px;align-items:center;">
        <input type="text" placeholder="Photo URL" [(ngModel)]="newPhotoUrl" class="form-control" style="flex:1.2;">
        <input type="text" placeholder="Description" [(ngModel)]="newPhotoDescription" class="form-control" style="flex:1;">
        <button class="rana-action-btn rana-action-btn-success" style="white-space:nowrap;" (click)="uploadPhoto()">
            <i class="uil uil-image-plus"></i> Add Photo
        </button>
    </div>

    <!-- Photo Grid -->
    <div class="rana-photo-grid" *ngIf="photos.length > 0">
        <div class="rana-photo-card" *ngFor="let photo of photos" [class.selected]="selectedPhoto === photo">
            <div class="rana-photo-img-wrap" (click)="selectedPhoto = selectedPhoto === photo ? undefined : photo">
                <img [src]="photo.url" alt="" class="rana-photo-img">
                <span class="rana-badge"
                      *ngIf="photo.moderated !== undefined"
                      [ngClass]="photo.moderated ? 'rana-badge-success' : 'rana-badge-danger'"
                      style="position:absolute;bottom:8px;left:8px;">
                    {{ photo.moderated ? 'Approved' : 'Rejected' }}
                </span>
                <span class="rana-badge rana-badge-warning" *ngIf="photo.moderated === undefined" style="position:absolute;bottom:8px;left:8px;">
                    Pending Review
                </span>
                <div class="rana-photo-overlay-actions">
                    <div class="rana-photo-icon-btn" title="Approve" (click)="$event.stopPropagation(); moderatePhoto(photo, true)">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#1F9D6B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 9 17 20 6"/></svg>
                    </div>
                    <div class="rana-photo-icon-btn" title="Reject" (click)="$event.stopPropagation(); moderatePhoto(photo, false)">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#C0392B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    </div>
                    <div class="rana-photo-icon-btn" title="Delete" (click)="$event.stopPropagation(); deletePhoto(photo)">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#8A7F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                    </div>
                </div>
            </div>
            <div class="rana-photo-body" (click)="selectedPhoto = selectedPhoto === photo ? undefined : photo">
                <div class="rana-photo-desc">{{ photo.description || 'No description' }}</div>
                <div class="rana-photo-comment-count">
                    {{ photo.comments?.length || 0 }} comment{{ photo.comments?.length === 1 ? '' : 's' }}
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!photos?.length" class="text-muted text-center mt-3">
        No photos uploaded yet.
    </div>

    <!-- Detail / Comments panel for the selected photo -->
    <div class="rana-panel mt-3" *ngIf="selectedPhoto">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px;">
            <div>
                <div class="rana-panel-title" style="margin-bottom:2px;">{{ selectedPhoto.description || 'No description' }}</div>
                <div class="small text-muted">
                    Status: {{ selectedPhoto.moderated === undefined ? 'Pending Review' : (selectedPhoto.moderated ? 'Approved' : 'Rejected') }}
                </div>
            </div>
            <button type="button" class="rana-action-btn" (click)="selectedPhoto = undefined">Close</button>
        </div>

        <div *ngIf="selectedPhoto.comments?.length" style="display:flex;flex-direction:column;gap:10px;margin-bottom:14px;">
            <div *ngFor="let comment of selectedPhoto.comments" style="border-top:1px solid var(--rana-border-soft);padding-top:10px;">
                <div style="font-size:13px;color:var(--rana-text);">{{ comment.comment }}</div>
                <div class="small text-muted">{{ comment.userId }}</div>
            </div>
        </div>
        <p class="text-muted small" *ngIf="!selectedPhoto.comments?.length">No comments yet.</p>

        <div style="display:flex;gap:10px;">
            <input type="text" placeholder="Add a comment" [(ngModel)]="newComment" class="form-control form-control-sm" style="flex:1;">
            <button class="rana-action-btn" (click)="addComment(selectedPhoto)">Comment</button>
        </div>
    </div>

</div>
